import React from 'react';
import { Box } from '@chakra-ui/react';
import CalendarioPsicologia from './CalendarioPsicologia';

const Psicologia: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <CalendarioPsicologia />
  </Box>
);

export default Psicologia;
